import * as actionTypes from '../../Action/actionTypes';

const initialState = {
  receptionTable_data: {
    columns: [
      {
        label: 'Full Name',
        field: 'name',
        sort: 'asc'
      },
      {
        label: 'User Name',
        field: 'userName',
        sort: 'asc'
      },
      {
        label: 'Email',
        field: 'email',
        sort: 'asc'
      },
      {
        label: 'Role',
        field: 'role',
        sort: 'asc'
      },
      {
        label: 'Branch Count',
        field: 'branch',
        sort: 'asc'
      },
      {
        label: 'Status',
        field: 'status',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ],
  },
  systemUser: {
    columns: [
      {
        label: 'Full Name',
        field: 'name',
        sort: 'asc'
      },
      {
        label: 'User Name',
        field: 'userName',
        sort: 'asc'
      },
      {
        label: 'Email',
        field: 'email',
        sort: 'asc'
      },
      {
        label: 'Mobile',
        field: 'mobile',
        sort: 'asc'
      },
      {
        label: 'User Role',
        field: 'role',
        sort: 'asc'
      },
      {
        label: 'Status',
        field: 'status',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ],
    rows: []
  },
  receptionData: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_RECEPTION:
      return {
        ...state,
        receptionData: action.value
      };
    default:
      return state;
  }
};

export default reducer;
